import { lighter } from "./util";

export const getBoxStyles = (colour, theme) => {
	colour = colour || '#81c784';
	return {
		mt: '-1px', p: 0, border: '1px solid ' + colour, borderRadius: 1, backgroundColor: lighter(colour, 0.8, theme),
		'&:last-child': {
			// borderBottomLeftRadius: 4,
		},
	};
};

export const hiddenInputSx = {
	clip: 'rect(0 0 0 0)',
	clipPath: 'inset(50%)',
	height: 1,
	overflow: 'hidden',
	position: 'absolute',
	bottom: 0,
	left: 0,
	whiteSpace: 'nowrap',
	width: 1,
}